import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:h-full" }
const _hoisted_2 = { class: "grid w-full grid-cols-12 gap-4 pb-4 text-darkgray-800" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Branch")
], -1)
const _hoisted_4 = { class: "col-span-8 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Patient")
], -1)
const _hoisted_6 = { class: "col-span-8 text-right capitalize" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package"),
  /*#__PURE__*/_createElementVNode("p", { class: "pl-5 font-bold" }, "Add-ons")
], -1)
const _hoisted_8 = { class: "col-span-8 text-right" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Date")
], -1)
const _hoisted_11 = { class: "col-span-8 text-right" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Time")
], -1)
const _hoisted_13 = { class: "col-span-8 text-right" }
const _hoisted_14 = { class: "w-full mt-auto text-darkgray-800" }
const _hoisted_15 = {
  key: 0,
  class: "pt-4 mb-4 border-t border-gray-40"
}
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = { class: "grid grid-cols-12 gap-4 pb-4 mb-4 border-b border-gray-40" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package Fee")
], -1)
const _hoisted_19 = { class: "col-span-8 text-right" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Misc. Fees")
], -1)
const _hoisted_21 = { class: "col-span-8 text-right" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Discount")
], -1)
const _hoisted_23 = { class: "col-span-full" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "Total")
], -1)
const _hoisted_26 = { class: "col-span-6 text-right" }
const _hoisted_27 = { class: "text-xl font-bold" }

import ButtonComponent from '@/components/ButtonComponent.vue';

import PageLoader from "@/components/PageLoader.vue";
import { useBookingStore } from '@/store/booking';
import { computed, onMounted, ref } from 'vue';
import { formatter } from "@/helpers/NumberHelper";
import TextInput from '@/components/inputs/TextInput.vue';
import { useRoute, useRouter } from 'vue-router';
import booking from '@/classes/Booking';
import Pages from '@/classes/Pages';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingSummary',
  props: {
    totalColor: {
        type: String,
    },
    defaultTitle: {
        type: Boolean,
        default: true
    },
    hideNotification: {
        type: Boolean,
        default: false
    },
    isloader: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {



const route = useRoute()
const router = useRouter();
// State Instance
const bookingStoreState = useBookingStore();

// Data
const loader = ref(false);
const selectedBranch = computed(() => bookingStoreState.bookingSummary?.selectedBranch);
const selectedPatient = computed(() => bookingStoreState.bookingSummary?.selectedPatient);
const selectedPackage = computed(() => bookingStoreState.bookingSummary?.selectedPackage);
const selectedAddOns = computed(() => bookingStoreState.bookingSummary?.selectedAddOns);
const selectedDate = computed(() => bookingStoreState.bookingSummary?.selectedDate);
const selectedTime = computed(() => bookingStoreState.bookingSummary?.selectedTime);
const packageFee = computed(() => bookingStoreState.bookingSummary?.packageFee);
const miscFee = computed(() => bookingStoreState.bookingSummary?.miscFee);
const totalFee = computed(() => bookingStoreState.bookingSummary?.totalFee);

const discountCode = ref<string|null>(bookingStoreState.bookingPayload?.discount_code)
const discount = computed(() => bookingStoreState.bookingSummary?.discount);
const errors = ref([])
const summaryNotes = ref('')

//METHODS
const applyDiscount = async () => {
    loader.value = true;
    
    if(discount.value < 1){

        discountCode.value = discountCode.value ? discountCode.value.toUpperCase() : null;

        await booking.applyVoucher({
            ...bookingStoreState.bookingPayload,
            rider_ids: bookingStoreState.bookingPayload.riders,
            code: discountCode.value
        })
        .then((result: any) => {
            bookingStoreState.bookingSummary.discount = result.data.applied_discount_fee
            bookingStoreState.bookingSummary.totalFee = totalFee.value - result.data.applied_discount_fee
            bookingStoreState.bookingPayload.other_charges_fee = totalFee.value
            
            bookingStoreState.bookingPayload.discount_code = result.data.voucher_code
            bookingStoreState.bookingPayload.discount_amount = result.data.applied_discount_fee

            errors.value = [];
        })
        .catch(err => {
            console.log(err)
            errors.value = err.response.data.errors;
        })
        .finally(() => {
            loader.value = false;
        })
    }
    else{
        bookingStoreState.bookingSummary.totalFee = totalFee.value + discount.value
        bookingStoreState.bookingSummary.discount = 0
        bookingStoreState.bookingPayload.other_charges_fee = totalFee.value
        discountCode.value = ''

        bookingStoreState.bookingPayload.discount_code = null;
        bookingStoreState.bookingPayload.discount_amount = null;

        loader.value = false;
    }
}

const fetchNotes = async() => {
    await Pages.fetchSlug('booking')
        .then((result: any) => {
            summaryNotes.value = result.data?.page.content;     
        })
        .catch((err) => {
            console.log(err)
        })
}

const isLastStep = computed( () => route.name == "SelectDateAndTime" || route.name == "ConfirmBooking");

onMounted(async () => {
    await fetchNotes()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(selectedBranch.value || '--'), 1)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(selectedPatient.value?.selected || '--'), 1)
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", null, _toDisplayString(selectedPackage.value || '--'), 1),
          (selectedAddOns.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedAddOns.value, (selectedAddOn, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "text-xs",
                  key: index
                }, _toDisplayString(selectedAddOn.item_name), 1))
              }), 128))
            : (_openBlock(), _createElementBlock("p", _hoisted_9, "--"))
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(selectedDate.value || '--'), 1)
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", null, _toDisplayString(selectedTime.value || '--'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_unref(route).path === '/booking/select-date-and-time')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(TextInput, {
                  modelValue: discountCode.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((discountCode).value = $event)),
                  id: "discount-code",
                  type: "text",
                  placeholder: "Discount Code",
                  "custom-class": "pr-20 uppercase",
                  disabled: discount.value > 0,
                  error: errors.value.code ? errors.value.code[0] : ''
                }, null, 8, ["modelValue", "disabled", "error"]),
                _createElementVNode("p", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (applyDiscount())),
                  class: _normalizeClass(["absolute right-10 top-[25%] text-primary-500 text-sm font-bold cursor-pointer", [discount.value > 0? 'text-red-600' : '', loader.value ? 'opacity-50 cursor-not-allowed' : '']])
                }, _toDisplayString(discount.value > 0 ? 'REMOVE' : 'APPLY'), 3)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(packageFee.value) || 0.00), 1)
          ]),
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(miscFee.value) || 0.00), 1)
          ]),
          _hoisted_22,
          _createElementVNode("div", {
            class: _normalizeClass(["col-span-8 text-right",  discount.value > 0  ? 'text-red-500' : null ])
          }, [
            _createElementVNode("p", null, " - " + _toDisplayString(discount.value > 0  ? _unref(formatter).format(discount.value) : ''), 1)
          ], 2),
          _createElementVNode("div", _hoisted_23, [
            (summaryNotes.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "text-sm text-neutral-400",
                  innerHTML: summaryNotes.value?.summary_note_title
                }, null, 8, _hoisted_24))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["grid grid-cols-12 gap-2.5 mb-5", __props.totalColor ? __props.totalColor : 'text-darkgray-800'])
        }, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(formatter).format(totalFee.value) || 0.00), 1)
          ])
        ], 2),
        _createVNode(ButtonComponent, {
          disabled: !isLastStep.value || _ctx.isLoader,
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('book-now')), ["prevent"])),
          class: "w-full",
          text: "Request Booking"
        }, null, 8, ["disabled"])
      ])
    ]),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})